import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { Paths } from '../../../enums/paths.enum';
import { RouteLabels } from '../../../enums/routeLabels.enum';
import { AuthGuard } from '../../../shared/auth.guard';
import { CanDeactivateGuard } from '../../../shared/can-deactivate.guard';
import { AddOrEditCompanyPage2 } from '../add-edit-company/add-edit-company2.page';
import { AnalyticsCompanyPage } from '../analytics-company/analytics-company.page';
import { AnalyticsCompanyModule } from '../analytics-company/analytics-company.module';
import { CompanyIntegrationsPage } from '../company-integrations/company-integrations.page';
import { CompanyProjectsOverviewPage } from '../company-projects-overview/company-projects-overview.page';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', redirectTo: `${Paths.PROJECT}`, pathMatch: 'full' },
            {
                path: `${Paths.PROJECT}`,
                component: CompanyProjectsOverviewPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.PROJECT_MAIN_NAVIGATION,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.PROFILE}`,
                component: AddOrEditCompanyPage2,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.COMPANY_PROFILE,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.INTEGRATIONS}`,
                component: CompanyIntegrationsPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.COMPANY_INTEGRATIONS,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.ANALYTICS}`,
                component: AnalyticsCompanyPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.COMPANY_ANALYTICS,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
        ],
    },
];

@NgModule({
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes), AnalyticsCompanyModule],
})
export class CompanyDetailsModule {}
